import { setArrayPrototype } from "./Array";
import { setDatePrototype } from "./date";

const setPrototypes = () => {
	setDatePrototype();
	setArrayPrototype();
};

export default setPrototypes;
